import { Component, OnInit } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { AddMemberProgrammeComponent } from 'src/app/components/modals/add-member-programme/add-member-programme.component';
import { ProgrammeService } from 'src/app/services/programme.service';
import { Account } from 'src/app/models/account';
import { ActivatedRoute } from '@angular/router';
import { ProgrammeMember } from 'src/app/models/programmeMember';
import { CoursePickerComponent } from 'src/app/components/modals/course-picker/course-picker.component';
import { ProgrammeCourse } from 'src/app/models/programmeCourse';
import { Programme } from 'src/app/models/programme';
import { MatSnackBar } from '@angular/material';
import { AddCoursesComponent } from 'src/app/components/modals/add-courses/add-courses.component';
import { PracticeService } from 'src/app/services/practice.service';

@Component({
  selector: 'app-programme',
  templateUrl: './programme.component.html',
  styleUrls: ['./programme.component.scss']
})
export class ProgrammeComponent implements OnInit {
  public programme_id:number;
  public programme:Programme;
  public members: Account[];
  private membersArray=[];
  public courses: ProgrammeCourse[];
  public loadedCourses: boolean = false;
  public loadedMembers: boolean = false;
  public loadedProgramme: boolean = false;
  public breadcrumbLinks=[{routerLink:'/programmes', label: 'Your Training Programmes'}];
  public thisPage:string='';
  public myPractice;

  constructor(
    public dialog: MatDialog,
    private programmeService: ProgrammeService,
    private route: ActivatedRoute,
    private _notify: MatSnackBar,
    private _practice: PracticeService
  ) {
    this._practice.getMyPractice().subscribe(
      res=>{
        if(res.id) {
          this.myPractice=res;
        }
      }
    );
    this.route.params.subscribe(res=>{
      this.programme_id = res.id;
    });
   }

  ngOnInit() {
    this.getMembers();
    this.getProgrammeCourses();
    this.getProgramme();
  }

  public notify(message:string, action:string) {
    this._notify.open(message, action, {
      duration: 4000,
      verticalPosition: 'top'
    });
  }

  getProgramme(){
    this.programmeService.getProgramme(this.programme_id).subscribe(
      res => {
        this.programme=res;
        this.thisPage=res.name;
        this.loadedProgramme=true;
      }
    );
  }

  formatStartDate(event){
    this.programme.start_date=event.value.toISOString();
  }

  formatCloseDate(event){
    this.programme.close_date=event.value.toISOString();
  }

  updateProgrammeDetails(){
    this.programmeService.updateProgramme(this.programme).subscribe(
      res=>{
        this.notify('Programme updated.','OK');
      }
    );
  }

  getMembers(){
    this.membersArray = [];
    this.programmeService.getProgrammeMembers(this.programme_id).subscribe(members=>{
      this.members = members;
      members.forEach(member=>{
        this.membersArray.push(member.user_id);
      });
      this.loadedMembers = true;
    })
  }

  addMembers(){
    const dialogRef = this.dialog.open(AddMemberProgrammeComponent, {
      width: '650px',
      data: {preSelected:this.membersArray,programme_id:this.programme_id}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        if(result.length!=0){
          this.programmeService.addMembers(result,this.programme_id).subscribe(res=>{
            this.getMembers();
          })
        }
      }
    });
  }

  notifyAllMembers(){
    if(confirm('Notify all programme members that this programme is available?')){
      this.programmeService.notifyMembers(this.programme_id).subscribe(res=>{
        // console.log(res);
      });
    }
  }

  removeMember(programmeMember:ProgrammeMember){
    this.programmeService.deleteMember(programmeMember).subscribe(res=>{
      this.getMembers();
    })
  }

  removeCourse(programmeCourse:ProgrammeCourse){
    if(!confirm('Remove course from Programme')) return;
    this.programmeService.deleteCourse(programmeCourse).subscribe(res=>{
      this.getProgrammeCourses();
    })
  }

  coursePicker(){
    const dialogRef = this.dialog.open(AddCoursesComponent, {
      width: '575px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        result.forEach(res=>{
          let programmeCourse = new ProgrammeCourse;
          programmeCourse.course_id = res.id;
          programmeCourse.programme_id = this.programme_id;
          this.programmeService.addCourse(programmeCourse).subscribe(res=>{
            this.getProgrammeCourses();
          })
        });
      }
    });
  }

  getProgrammeCourses(){
    this.loadedCourses = false;
    this.programmeService.getProgrammeCourses(this.programme_id).subscribe(courses=>{
      this.courses = courses;
        this.loadedCourses = true;
    })
  }
}
